var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"not-found-status"},[_vm._v("404")]),_c('h2',{staticClass:"not-found-message"},[_vm._v("Not Found")])])])
}]

export { render, staticRenderFns }